//html解码
function htmlDecode(str) {
  var s = "";
  if (str.length === 0) return "";
  s = str.replace(/&amp;/g, "&");
  s = s.replace(/&lt;/g, "<");
  s = s.replace(/&gt;/g, ">");
  s = s.replace(/&#39;/g, '"');
  s = s.replace(/&quot;/g, '"');
  return s;
}

function InterceptStr(value, value_length) {
  let str_length = 36;
  if (value_length) {
    str_length = value_length;
  }
  if (value && value.length > str_length) {
    value = value.substring(0, str_length) + "...";
  }
  return value;
}

function changeTitle(title) {
  document.getElementsByTagName("title")[0].innerText = title;
}

function formatTime(value) {
  var secondTime = parseInt(value); // 秒
  var minuteTime = 0; // 分
  var hourTime = 0; // 小时
  if (secondTime > 59) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 59) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  var result = `${
    parseInt(hourTime) > 9 ? parseInt(hourTime) : "0" + parseInt(hourTime)
  }:${
    parseInt(minuteTime) > 9 ? parseInt(minuteTime) : "0" + parseInt(minuteTime)
  }:${
    parseInt(secondTime) > 9 ? parseInt(secondTime) : "0" + parseInt(secondTime)
  }`;
  return result;
}

function formatDate(date) {
  let formatDate =
    date.getFullYear() +
    "." +
    (date.getMonth() + 1) +
    "." +
    date.getDate() +
    " " +
    date.getHours() +
    ":" +
    (date.getMinutes() < 10 ? "0" : "") +
    date.getMinutes() +
    ":" +
    (date.getSeconds() < 10 ? "0" : "") +
    date.getSeconds();
  return formatDate;
}

function formatBirthday(date) {
  let formatDate =
    date.getFullYear() +
    "-" +
    (date.getMonth() < 9 ? "0" : "") +
    (date.getMonth() + 1) +
    "-" +
    (date.getDate() < 10 ? "0" : "") +
    date.getDate();
  return formatDate;
}

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

//判断是否是微信浏览器
function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  //只能用==不能用恒等
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

function navTo(nav, params, that) {
  let url = "home";
  let data = {};
  if (nav) {
    url = nav;
  }
  if (params) {
    data = params;
  }
  var path = { pathname: url, state: data };
  that.props.history.push(path);
}

function switchTo(nav, params, that) {
  let url = "home";
  let data = {};
  if (nav) {
    url = nav;
  }
  if (params) {
    data = params;
  }
  var path = { pathname: url, state: data };
  that.props.history.replace(path);
}

exports.InterceptStr = InterceptStr;
exports.htmlDecode = htmlDecode;
exports.changeTitle = changeTitle;
exports.formatTime = formatTime;
exports.formatDate = formatDate;
exports.getUrlParam = getUrlParam;
exports.isWeiXin = isWeiXin;
exports.navTo = navTo;
exports.switchTo = switchTo;
exports.formatBirthday = formatBirthday;
